// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"abf521e4c6e3b28b3887","691":"99ed8925da57bd45caec"}[chunkId] + ".js";
};